import React, { useState } from "react";

interface RevealTextboxProps {
    label?: string;
    value: string;
    onChange?: (newValue: string) => void;
}

export const RevealTextbox: React.FC<RevealTextboxProps> = ({ label, value, onChange }) => {
    const [revealed, setRevealed] = useState(false);

    return (
        <div className="space-y-1">
            {label && <label className="block text-sm font-medium text-gray-700">{label}</label>}
            <div className="flex items-center space-x-2">
                <input
                    type={revealed ? "text" : "password"}
                    value={value}
                    onChange={(e) => onChange?.(e.target.value)}
                    className="flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900"
                />
                <button
                    type="button"
                    onClick={() => setRevealed(!revealed)}
                    className="rounded-md border px-3 py-1 text-sm font-medium text-gray-700 hover:bg-gray-100"
                >
                    {revealed ? "Hide" : "Show"}
                </button>
            </div>
        </div>
    );
};
